import styled, { css } from 'styled-components';
import { Name } from '../../index.view';
import { Collapse as CollapseMui } from '@material-ui/core';

const Collapse = styled(CollapseMui)`
  .MuiCollapse-wrapper {
    width: 100%;
  }
  .MuiCollapse-wrapperInner {
    width: 100%;
  }
`;

const CondimentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 0.3rem;

  > :first-child {
    max-width: 80%;

    ${({ theme: { mui } }) => css`
      ${mui.breakpoints.down('xs')} {
        max-width: 68%;
      }
    `}
  }
`;

const Detail = styled(Name)`
  font-size: 12px;
  color: ${({ theme: { color } }) => color.gray_400};
  line-height: initial;
  margin: 5px 0;
`;

export { Collapse, CondimentWrapper, Detail };
